<div class="flex-h-c pt20 pb20 f14" style="width:300px;">
    <span (click)="previousYear()" class="poi pl10 pr10">
        <i style="transform:rotate(90deg);margin-right: -4px;" class="fas fa-minus"></i>
        <i class="fas fa-chevron-left"></i>
    </span>
    <span (click)="previousMonth()" class="poi pl10 pr10"><i class="fas fa-chevron-left"></i></span>
    <span class="f-g f-s tc f16"><span class="mr6 poi"
            (click)="onMonthClick()">{{calendar.activeDate|date:'MMMM'}}</span><span class="poi"
            (click)="onYearClick()">{{calendar.activeDate|date:'y'}}</span></span>
    <span (click)="nextMonth()" class="poi pl10 pr10"><i class="fas fa-chevron-right"></i></span>
    <span (click)="nextYear()" class="poi pl10 pr10"><i class="fas fa-chevron-right"></i><i
            style="transform:rotate(90deg);margin-left: -4px;" class="fas fa-minus"></i></span>
</div>
<a-mat-calendar-year *ngIf="view==='year'" [minDate]="calendar.minDate" [maxDate]="calendar.maxDate"
    [activeDate]="calendar.activeDate" [currentYear]="currentYear" (onYearClick)="onYearSelected($event)">
</a-mat-calendar-year>
<a-mat-calendar-month *ngIf="view==='month'" [minDate]="calendar.minDate" [maxDate]="calendar.maxDate"
    [activeDate]="calendar.activeDate" [currentYear]="selectYear" (onMonthClick)="onMonthSelected($event)"
    (onBackToYear)="backToYearView($event)">
</a-mat-calendar-month>